import { render, staticRenderFns } from "./Fabric.vue?vue&type=template&id=163932db&scoped=true&"
import script from "./Fabric.vue?vue&type=script&lang=js&"
export * from "./Fabric.vue?vue&type=script&lang=js&"
import style0 from "./Fabric.vue?vue&type=style&index=0&id=163932db&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "163932db",
  null
  
)

export default component.exports